import * as API from "middleware/api";

export const getCurrentStep = () => API.executeWithAccessToken("/onboarding.environment.getCurrentStep");

export const saveGeneralData = (params) => API.executeWithAccessToken("/onboarding.environment.generalData", params);

export const getComplementaryDataSelectors = (params) =>
    API.executeWithAccessToken("/onboarding.environment.complementaryDataSelectors", params);

export const getGeneralSelectors = () => API.executeWithAccessToken("/onboarding.environment.generalDataSelectors");

export const verifyUifDetails = (params) => API.executeWithAccessToken("/onboarding.uif.verify", params);
export const saveComplementaryData = (params) =>
    API.executeWithAccessToken("/onboarding.environment.complementaryData", params);

export const saveLegalRepresentative = (params) =>
    API.executeWithAccessToken("/onboarding.environment.legalRepresentativeData", params);

export const saveShareholders = (params) =>
    API.executeWithAccessToken("/onboarding.environment.shareholdersData", params);

export const verifyPerson = (params) => API.executeWithAccessToken("/onboarding.environment.verifyPerson", params);

export const uploadDocument = (params) => API.executeWithAccessToken("/onboarding.environment.uploadDocument", params);

export const saveDocumentation = (params) =>
    API.executeWithAccessToken("/onboarding.environment.documentationData", params);

export const getBeneficiariesSelectors = () =>
    API.executeWithAccessToken("/onboarding.environment.beneficiariesSelectors");

export const listStates = (params) => API.executeAnonymous("/onboarding.states.list", params);

export const listShareholdersBeneficiaries = () =>
    API.executeWithAccessToken("/onboarding.environment.beneficiaryShareholders.list");

export const saveFinalBeneficiaries = (params) =>
    API.executeWithAccessToken("/onboarding.environment.finalBeneficiariesData", {
        finalBeneficiariesData: params,
    });

export const saveProxy = (params) => API.executeWithAccessToken("/onboarding.environment.proxiesData", params);

export const getTaxSelectorRequest = () => API.executeWithAccessToken("/onboarding.environment.taxDataSelectors");

export const saveTax = (params) => API.executeWithAccessToken("/onboarding.environment.taxData", params);

export const getStepData = (params) => API.executeWithAccessToken("/onboarding.environment.getSpecificStep", params);

export const deleteShareholder = (params) =>
    API.executeWithAccessToken("/onboarding.environment.delete.personalData", params);

export const verifyPersonRoles = (params) =>
    API.executeWithAccessToken("/onboarding.environment.verifyPersonRoles", params);

export const acceptPaywayRequest = (params) => API.executeWithAccessToken("/onboarding.payway.first.step", params);

export const savePaywayTerminalTypeRequest = (params) =>
    API.executeWithAccessToken("/onboarding.payway.selectTerminalType.step", params);

export const getIsPaywayAcceptedRequest = () => API.executeWithAccessToken("/onboarding.user.getPaywayAccepted");

export const getPaywayCategoriesRequest = () => API.executeWithAccessToken("/onboarding.get.payway.categories");

export const getAreTyCAccepted = () => API.executeWithAccessToken("/onboarding.verify.pj.terms.acceptance");

export const savePaywayCategoryRequest = (params) =>
    API.executeWithAccessToken("/onboarding.payway.selectCategory.step", params);

export const savePaywayTerminalsDataRequest = (params) =>
    API.executeWithAccessToken("/onboarding.payway.saveTerminalsData.step", params);

export const lastStepPayway = () => API.executeWithAccessToken("/onboarding.payway.last.step");
